import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-043b3f62"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "name",
  id: "edit-name"
}
const _hoisted_2 = {
  key: 2,
  class: "mask-edit"
}
const _hoisted_3 = {
  key: 3,
  class: "mask"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-pinned" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-content" }, "a")
], -1))
const _hoisted_5 = {
  class: "more-manu",
  width: 100
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-pin" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-content" }, "content")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-unpin" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-content" }, "content")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-rename" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-content" }, "content")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-delete" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-content" }, "content")
], -1))

import { ref,nextTick,computed } from 'vue'
import { MoreFilled } from '@element-plus/icons-vue'
import { ChatSession } from '@/typings'


export default /*#__PURE__*/_defineComponent({
  __name: 'SessionItem',
  props: {
    active: { type: Boolean },
    session: {}
  },
  emits: ["pin", "delete", "switch", "update"],
  setup(__props: any, { emit: __emit }) {

const popoverShowStatus = ref(false);

//标记是否可编辑
const isEdit = ref(false);
//记录当前选中的会话
const focusedSession = ref({}as ChatSession);
// active：用来标记当前会话是否处于选中状态
// session：用于展示的会话信息
const props = __props
// 定义删除事件，当触发删除事件时会向外部发送被删除的会话。
const emit = __emit

const enterBlur = (event:Event) => {
    if(event.target)
    {
        (event.target as HTMLInputElement).blur();    
    }
}
const isPinned = computed(() => props.session.pin==1)
const popoverRef = ref({} as any);
const sendPinConversation = async () =>{
    if (popoverRef.value) {
        await popoverRef.value.hide(); // 等待菜单隐藏完成
        setTimeout(() => {
          emit('pin', props.session); // 延迟发送 pin 事件
        }, 200); // 使用0毫秒的延迟
      }
}
// 当鼠标放到会话上时，会弹出删除图标，点击删除图标调用删除接口并发送删除事件。
const sendDeleteConversation = () => {
    emit('delete', props.session);
}

const sendSwitchConversation = () => {
    emit('switch', props.session);
}

const showNameEditInput = () => {
    isEdit.value = true;
    popoverShowStatus.value = false;
    nextTick(() => {
      const inputElement = document.getElementById("sessionInputId");
      if (inputElement) {
        inputElement.focus();
      }
    })
}

const sendUpdateConversation = () => {
    isEdit.value = false;
    popoverShowStatus.value = false;
    emit('update', props.session);
}

const selectSession = () => {
    focusedSession.value = props.session;
}

const judgeEdit = () =>{
    return isEdit.value && focusedSession.value.guid == props.session.guid;
}

const show = ()=>
{
    popoverShowStatus.value = true;
}

const hide = ()=>
{
    popoverShowStatus.value = false;
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['session-item', _ctx.active ? 'active' : ''])
  }, [
    (judgeEdit())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.session.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.session.title) = $event)),
            class: "name-input",
            id: "sessionInputId",
            onBlur: sendUpdateConversation,
            onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (enterBlur($event)), ["enter","native"]))
          }, null, 8, ["modelValue"])
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "name",
          id: "show-name",
          onClick: sendSwitchConversation
        }, _toDisplayString(_ctx.session.title), 1)),
    (judgeEdit() ||(focusedSession.value && focusedSession.value.guid === props.session.guid && popoverShowStatus.value))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3)),
    (!judgeEdit())
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: _normalizeClass(['btn-wrapper', { 'pinned': isPinned.value }])
        }, [
          _createVNode(_component_el_popover, {
            "popper-class": "popover",
            ref_key: "popoverRef",
            ref: popoverRef,
            placement: "bottom",
            trigger: "click",
            onShow: show,
            onHide: hide
          }, {
            reference: _withCtx(() => [
              (!_ctx.session.pin)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "more-button",
                    onClick: selectSession
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { class: "el-icon-more" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MoreFilled))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    class: "pinned-button",
                    onClick: selectSession
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }))
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                (!_ctx.session.pin)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      class: "pin-button",
                      type: "primary",
                      onClick: sendPinConversation
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("slider.pin")), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      class: "unpin-button",
                      type: "primary",
                      onClick: sendPinConversation
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("slider.unpin")), 1)
                      ]),
                      _: 1
                    })),
                _createVNode(_component_el_button, {
                  class: "rename-button",
                  type: "primary",
                  onClick: showNameEditInput
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("slider.rename")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  class: "delete-button",
                  type: "primary",
                  onClick: sendDeleteConversation
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("slider.delete")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 512)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})